/*
 * Ryan O'Dowd
 * 2022-04-18
 * © Copyright 2022 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({globalScale, colors}) => {
  return {
    container: {
      flex: 1,
      flexDirection: 'column',
      width: '100%',
      maxWidth: 500,
      justifyContent: 'flex-start',
      textAlign: 'left',
    },
    fullWidth: {
      width: '100%',
    },
    submitButton: {
      marginTop: globalScale * 8,
    },
    thanksText: {
      color: colors.primary,
    },
  };
};

export default getStyles;
